module.exports = __webpack_public_path__ + "img/sankaku_39_red.07eb8e10.png";